window['$'] = window['jQuery'] = require("../../../static/js/jquery/jquery-3.3.1.min.js");
require("../../../static/js/main.js");
window['Spinner'] = require("../../../static/js/spin.min.js");
window['Popper'] = require("../../../static/js/popper.min.js");
require("../../../static/js/bootstrap-v4.1.3.js");
require("../../../static/js/gateway.js");
require("../../../static/js/slick/slick.min.js");
require("../../../static/js/header/scripts.js");
require("../../../static/eu/js/header/header-override.js");
